import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../routing/routes";
import { composePathWithParams } from "../../utils/url";
import Button from "../shared/button/Button";
import { getStandLevelName } from "../../utils/mapping";
import { Stand } from "../../data/interfaces";
import _environment from "../../_environment/_environment";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  stand: Stand;
  isChat?: boolean;
}

const StandBox = ({ isChat, stand, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const goToStand = (): void => {
    if (!isChat) {
      history.push(composePathWithParams(ROUTES.STAND_DETAIL, [{ id: stand.id }]));
    }
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------
  const renderBadge = (): React.ReactNode => {
    return (
      <>
        <span className={`meeters-iconset-${getStandLevelName(stand.level)} meeters-badge`} />
      </>
    );
  };

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[StandBox] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[StandBox] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      {((!!isChat && !!stand.mattermost?.slug) || !isChat) && (
        <div onClick={goToStand} className={"flip-card box stand-box level-" + stand.level}>
          <div className="flip-card-inner">
            <div className="flip-card-front">
              {renderBadge()}
              <div
                className="logo"
                style={{ backgroundImage: `url(${stand.logo_image_url})` }}
              ></div>
              {/* <div className="level">
                            <i className="fas fa-certificate"></i>
                        </div> */}
            </div>
            <div className="flip-card-back">
              {renderBadge()}
              <h5 className={"name"}>{stand.name}</h5>
              {/* <ul className={"tags clearfix"}>
                            {stand.tags.map((tag: string) => (
                                <li key={tag}>{`#${tag}`}</li>
                            ))}
                        </ul> */}
              {/* {stand.level > 0 && (
                            <span className={"description"}>{stand.description}</span>
                        )} */}

              {!isChat && (
                <Button onClick={goToStand} className="btn btn-primary">
                  Visit
                </Button>
              )}

              {!!isChat && !!stand.mattermost?.slug && (
                <a
                  href={`${_environment.mattermost.URL}/${stand.mattermost.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Chat
                  <i className="fas fa-comments"></i>
                </a>
              )}
            </div>
          </div>
          {/* <div className="ribbon"><span>{getStandLevelName(stand.level)}</span></div> */}
        </div>
      )}
    </>
  );
};
export default StandBox;
